<template>
  <div class="row sessoesSubaba">
    <div class="col col-md-10 offset-md-1 text-center sessoesSubabaCorpo">
      <header class="sessoesSubabaCabecalho">
        <div>
          <span>Distribuição ativa</span>
          <h2>
            {{ propView == "evento" ? "Sessões por evento" : "Sessões por servidor" }}
          </h2>
        </div>
        <strong>{{ itens.length }}</strong>
      </header>

      <div class="d-flex justify-content-between sessoesSubabaFiltros">
        <Combo
          :itens="$global.sites_filtro_completo()"
          v-model="filtroSite"
          style="max-width: 150px; margin-right: 10px"
          v-if="
            retornaSite() !== 'Share' &&
            retornaSite() !== 'Stream1x2' &&
            retornaSite() !== '7live'
          "
        />

        <input
          class="form-control"
          style="margin-right: 10px"
          type="text"
          placeholder="Email..."
          v-model="filtroUsuario"
        />

        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          style
          @click="carregarItens()"
        >
          Filtrar
        </button>
      </div>

      <hr />

      <div v-if="carregando" class="sessaoResumoEstado">
        <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
        <span>Carregando dados</span>
      </div>

      <div v-else-if="erro" class="sessaoResumoEstado sessaoResumoErro">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <span>{{ erro }}</span>
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          @click="recarregar"
        >
          Tentar novamente
        </button>
      </div>

      <div v-else class="rowLista sessoesSubabaTabela">
        <div class="list-group-item list-group-item-dark text-left">
          <div class="row">
            <div class="col">
              <h5 style="margin-top: 9px">#</h5>
            </div>
            <div class="col col-md-3 text-center">
              <h5 style="margin-top: 9px">Usuários</h5>
            </div>
            <div class="col col-md-3 text-center">
              <h5 style="margin-top: 9px">Sessões</h5>
            </div>
          </div>
        </div>
        <div v-if="!itens.length" class="sessoesSubabaVazio">
          <i
            :class="propView == 'evento' ? 'fa fa-calendar-o' : 'fa fa-server'"
            aria-hidden="true"
          ></i>
          <span>Nenhuma sessão encontrada</span>
        </div>
        <div
          class="list-group-item list-group-item-action text-left sessoesSubabaLinha"
          v-for="item in itens"
          :key="item._id"
          :item="item"
          @click="clicouEvento(item._id)"
          style="cursor: pointer"
        >
          <div class="row">
            <div class="col">
              <h5 style="margin-top: 9px" v-if="propView == 'evento'">
                {{ itensEventos[item._id] }}
              </h5>
              <h5
                style="margin-top: 9px"
                v-if="propView == 'servidor'"
              >
                {{ nomeServidor(item) }}
              </h5>
              <div v-if="propView == 'evento'">
                <h6
                  v-for="itemServidor in item.servidores"
                  :key="itemServidor._id"
                  :item="itemServidor"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  Canal {{ itemServidor.canal }} -
                  {{ nomeServidor(itemServidor) }}
                </h6>
              </div>
              <div v-if="propView == 'servidor'">
                <h6
                  v-for="itemEvento in item.eventos"
                  :key="itemEvento._id"
                  :item="itemEvento"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  (Canal {{ itemEvento.canal }})
                  {{ nomeEvento(itemEvento) }}
                </h6>
              </div>
            </div>
            <div class="col col-md-3 text-center">
              <h5 v-if="propView == 'evento'" style="margin-top: 9px">
                {{ item.sessoesUsuario }}
              </h5>
              <h5 v-if="propView == 'servidor'" style="margin-top: 9px">-</h5>
              <div v-if="propView == 'evento'">
                <h6
                  v-for="itemServidor in item.servidores"
                  :key="itemServidor._id"
                  :item="itemServidor"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  -
                </h6>
              </div>
              <div v-if="propView == 'servidor'">
                <h6
                  v-for="itemEvento in item.eventos"
                  :key="itemEvento._id"
                  :item="itemEvento"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  {{ itemEvento.sessoesUsuario }}
                </h6>
              </div>
            </div>
            <div class="col col-md-3 text-center">
              <h5 style="margin-top: 9px">{{ item.sessoesTotal }}</h5>
              <div v-if="propView == 'evento'">
                <h6
                  v-for="itemServidor in item.servidores"
                  :key="itemServidor._id"
                  :item="itemServidor"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  {{ itemServidor.sessoesTotal }}
                </h6>
              </div>
              <div v-if="propView == 'servidor'">
                <h6
                  v-for="itemEvento in item.eventos"
                  :key="itemEvento._id"
                  :item="itemEvento"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  {{ itemEvento.sessoesTotal }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import Combo from "../components/Combo.vue";

export default {
  name: "ListSessaoViewResumoServidor",
  components: { Combo },
  props: {
    itensLimit: { type: Number, default: 10000 },
    propView: { type: String, default: "evento" },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    clicouEvento(id) {
      this.$emit("clicouEvento", id);
    },
    nomeServidor(item) {
      var servidores = this.$global.servidores_sip();
      var servidor = servidores[item.servidorTipo + "_" + item.servidor];

      return servidor && servidor.nome
        ? servidor.nome
        : item.servidor || "Servidor não identificado";
    },
    nomeEvento(item) {
      if (item.eventoDados && item.eventoDados.nome) {
        return item.eventoDados.nome;
      }

      return this.itensEventos[item.evento] || "Evento não identificado";
    },
    recarregar() {
      if (this.propView == "evento") {
        this.carregarItensEventos();
      } else {
        this.carregarItens();
      }
    },
    async carregarItens() {
      var filtros = ["_limit=" + this.itensLimit];
      this.itens = [];
      this.carregando = true;
      this.erro = "";

      if (this.filtroUsuario !== "") {
        filtros.push("usuario=" + encodeURIComponent(this.filtroUsuario));
      }

      if (this.filtroSite !== "Todos") {
        filtros.push("site=" + encodeURIComponent(this.filtroSite));
      }

      try {
        var response;
        var endpoint;

        if (this.propView == "evento") {
          endpoint = "/sessaoView/evento/servidor";
        } else {
          endpoint = "/sessaoView/servidor/evento-detalhado";
        }

        response = await api.get(endpoint + "?" + filtros.join("&"));
        api.valid(response.data, this.$router);

        if (response.data.erro) {
          throw new Error(
            response.data.mensagem || "Não foi possível carregar os dados."
          );
        }

        var itensEventos = this.itensEventos;
        var propView = this.propView;

        var resultItens = Object.values(response.data.itens || {}).filter(function (
          item
        ) {
          //item.sessoesUsuario = 0;
          //item.sessoesTotal = 0;

          if (propView == "evento") {
            /*
            for(var indiceServidor = 0;indiceServidor < item.servidores.length;indiceServidor++)
            {
              var servidor = item.servidores[indiceServidor];

              //item.sessoesUsuario = item.sessoesUsuario + servidor.sessoesUsuario;
              item.sessoesTotal = item.sessoesTotal + servidor.sessoesTotal;

            }
            */
            item.servidores = Object.values(item.servidores || {});
            item.servidores.sort((a, b) => b.sessoesTotal - a.sessoesTotal);

            return itensEventos[item._id];
          } else {
            item.eventos = Object.values(item.eventos || {});
            item.eventos.sort((a, b) => b.sessoesTotal - a.sessoesTotal);

            return true;
          }
        });

        resultItens.sort((a, b) => b.sessoesTotal - a.sessoesTotal);

        this.itens = resultItens;
      } catch (erro) {
        this.erro =
          erro && erro.message
            ? erro.message
            : "Não foi possível carregar os dados.";
      } finally {
        this.carregando = false;
      }
    },
    async carregarItensEventos() {
      var filtros = "";

      filtros += "?_limit=500";
      this.carregando = true;
      this.erro = "";

      try {
        const response = await api.get("/evento" + filtros);
        api.valid(response.data, this.$router);

        if (response.data.erro) {
          throw new Error(
            response.data.mensagem || "Não foi possível carregar os eventos."
          );
        }

        this.itensEventos = {};

        for (
          var indiceEvento = 0;
          indiceEvento < response.data.itens.length;
          indiceEvento++
        ) {
          var evento = response.data.itens[indiceEvento];

          this.itensEventos[evento._id] = evento.nome;
        }

        await this.carregarItens();
      } catch (erro) {
        this.erro =
          erro && erro.message
            ? erro.message
            : "Não foi possível carregar os eventos.";
        this.carregando = false;
      }
    },
    formatDateTime(datetime) {
      if (!datetime) return null;
      if (datetime && datetime != null && datetime != "") {
        var options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          //timeZoneName: "short",
          //timeZone: "UTC"
        };
        datetime = new Date(datetime);
        var portugueseTime = new Intl.DateTimeFormat(
          ["pt-BR", "pt-PT"],
          options
        );
        return portugueseTime.format(datetime);
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.recarregar();
  },
  data: function () {
    return {
      itens: [],
      itensEventos: {},
      filtroUsuario: "",
      filtroSite: "Todos",
      carregando: false,
      erro: "",
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.sessaoResumoEstado {
  align-items: center;
  color: #6c757d;
  display: flex;
  gap: 8px;
  justify-content: center;
  min-height: 120px;
}

.sessaoResumoErro {
  color: #a14545;
  flex-direction: column;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>
